import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";

const packages = [
  {
    icon: "🚀",
    title: "Starter Package",
    price: "₹25K - ₹30K",
    description:
      "Perfect for startups, local businesses and professionals.",
    features: [
      "Up to 5 Pages",
      "Responsive Design",
      "WhatsApp Integration",
      "Google Maps",
      "Basic SEO",
      "SSL Setup",
    ],
    handleContact: () => {
      window.open(
        "https://wa.me/919779552562?text=Hello%20YTC%20TechVenture%2C%20I%20am%20interested%20in%20your%20starter%20package.%20Please%20provide%20more%20details.",
        "_blank"
      );
    },
  },
  {
    icon: "📈",
    title: "Growth Package",
    price: "₹70K - ₹90K",
    popular: true,
    description:
      "Professional business website with lead generation.",
    features: [
      "10-15 Pages",
      "Premium UI/UX",
      "Admin Dashboard",
      "Lead Forms",
      "Analytics",
      "Automation",
    ],
      handleContact: () => {
      window.open(
        "https://wa.me/919779552562?text=Hello%20YTC%20TechVenture%2C%20I%20am%20interested%20in%20your%20growth%20package.%20Please%20provide%20more%20details.",
        "_blank"
      );
    },
  },
  {
    icon: "🏢",
    title: "Enterprise Package",
    price: "₹1.4L+",
    description:
      "ERP, CRM, PMS and custom business platforms.",
    features: [
      "ERP / CRM",
      "Reports",
      "Analytics",
      "Cloud Deployment",
      "Role Access",
      "API Integration",
    ],
      handleContact: () => {
      window.open(
        "https://wa.me/919779552562?text=Hello%20YTC%20TechVenture%2C%20I%20am%20interested%20in%20your%20enterprise%20software%20development%20services.%20Please%20provide%20more%20details.",
        "_blank"
      );
    },
  },
  {
    icon: "📱",
    title: "Mobile Platform",
    price: "₹2.4L+",
    description:
      "Android, iOS, Website & Backend Ecosystem.",
    features: [
      "Android App",
      "iOS App",
      "Admin Dashboard",
      "Backend APIs",
      "Push Notifications",
      "Payment Gateway",
    ],
    handleContact: () => {
      window.open(
        "https://wa.me/919779552562?text=Hello%20YTC%20TechVenture%2C%20I%20am%20interested%20in%20your%20mobile%20app%20development%20services.%20Please%20provide%20more%20details.",
        "_blank"
      );
    },
  },
];

const PricingSection = () => {
  const handleContact = () => {
    window.open(
      "https://wa.me/919779552562?text=Hello%20YTC%20TechVenture%2C%20I%20am%20interested%20in%20your%20development%20packages.%20Please%20provide%20more%20details.",
      "_blank"
    );
  };

  return (
    <>
      <Helmet>
        <title>
          Development Packages | YTC Tech Ventures
        </title>
      </Helmet>

      <section className="pricing-hero">
        <Container>
          <div className="pricing-header">
            <span>YTC TECH VENTURES</span>

            <h1>
              Build Your Next Digital Product
            </h1>

            <p>
              Websites, Mobile Apps, ERP Systems,
              CRM Platforms and Enterprise Software
              designed for growth.
            </p>
          </div>

          <Row className="g-4">
            {packages.map((pkg, index) => (
              <Col
                lg={3}
                md={6}
                key={index}
              >
                <div className="premium-package-card">

                  {pkg.popular && (
                    <div className="popular-badge">
                      MOST POPULAR
                    </div>
                  )}

                  <div className="package-icon">
                    {pkg.icon}
                  </div>

                  <h3>{pkg.title}</h3>

                  <div className="package-price">
                    {pkg.price}
                  </div>

                  <p>{pkg.description}</p>

                  <ul>
                    {pkg.features.map(
                      (feature, i) => (
                        <li key={i}>
                          ✓ {feature}
                        </li>
                      )
                    )}
                  </ul>

                  <button
                    className="package-btn"
                    onClick={pkg.handleContact}
                  >
                    Get Consultation
                  </button>

                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="stats-section">
        <Container>
          <Row>
            <Col md={3}>
              <div className="stat-card">
                <h2>100+</h2>
                <p>Projects Delivered</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="stat-card">
                <h2>50+</h2>
                <p>Happy Clients</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="stat-card">
                <h2>24/7</h2>
                <p>Support</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="stat-card">
                <h2>5★</h2>
                <p>Client Satisfaction</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="offer-section">
        <Container>
          <div className="offer-box">
            <h2>
              🎉 Limited Time Offer
            </h2>

            <p>
              Get Up To 20% OFF On Selected
              Development Packages
            </p>

            <button
              className="package-btn"
              onClick={handleContact}
            >
              Contact Sales Team
            </button>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PricingSection;